import Logger from '../logger';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';

// Register plugins with GSAP (ScrollTrigger must be registered before ScrollSmoother)
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollSmoother);

/**
 * SmoothScroll - Basic ScrollSmoother setup
 */
class SmoothScroll {

	constructor() {
		this.NAME = 'SmoothScroll';
		this.scrollSmoother = null;
	}

	/**
	 * init - Initialize ScrollSmoother
	 */
	init() {
		Logger.info(`${this.NAME} > init`);

		// Check for reduced motion preference
		if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
			Logger.info(`${this.NAME} > Reduced motion detected, smooth scroll disabled`);
			return;
		}

		// Disable on mobile for better performance
		if (window.innerWidth < 768) {
			Logger.info(`${this.NAME} > Mobile device detected, smooth scroll disabled`);
			return;
		}

		try {
			// Basic ScrollSmoother setup
			this.scrollSmoother = ScrollSmoother.create({
				smooth: 1, // Smoothness (1 = balanced, lower = faster)
				effects: true, // Enable parallax effects
			});

			Logger.info(`${this.NAME} > ScrollSmoother initialized successfully`);
		} catch (error) {
			Logger.error(`${this.NAME} > ScrollSmoother initialization failed:`, error);
		}
	}

	/**
	 * destroy - Clean up ScrollSmoother
	 */
	destroy() {
		if (this.scrollSmoother) {
			this.scrollSmoother.kill();
		}
	}
}

export default SmoothScroll;
